import { render, staticRenderFns } from "./ContactLinkedCompanies.vue?vue&type=template&id=c0ebc1dc&scoped=true&"
import script from "./ContactLinkedCompanies.vue?vue&type=script&lang=js&"
export * from "./ContactLinkedCompanies.vue?vue&type=script&lang=js&"
import style0 from "./ContactLinkedCompanies.vue?vue&type=style&index=0&id=c0ebc1dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ebc1dc",
  null
  
)

export default component.exports